import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from "@angular/router";
import { IClientOk } from '../layout/cobranza-digital/store/states/clientOk.state';
import { LoadClientOkFailed } from '../layout/cobranza-digital/store/actions/clientOk.action';
import { LoadAuthorize } from '../layout/cobranza-digital/store/actions/authorize.action';
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app.state";

@Injectable({
  providedIn: 'root',
})

export class PermissionsGuard  {

  constructor(
		private readonly router: Router,
    private readonly _store: Store<IAppState>
	) {}

  errrSesion : IClientOk ={
    error : {
      text: "Ingreso no permitido",
      message: "Ingreso no permitido",
      errorCodeHTTP: "",
      errorNameHTTP: "",
      errorDescription: "",
      errorDetails: {
        exceptionType: "USERSESSION",
        functionalErrorCode: "USERSESSION",
        functionalErrorDescription: "USERSESSION",
        operationName: "",
        serviceName: ""
      }
    },
    message: "",
    name: "",
    ok: false,
    status: 500,
    statusText: ""
  };
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let res: boolean = false;
    if(this.hasuser()){
      res = true;
    }else{
      setTimeout(()=>{
        res = false;
        this._store.dispatch(new LoadClientOkFailed(this.errrSesion));
        this.router.navigate(["/logout"]);
        return res;
      }, 1000);
    }
    return res;
  }

  hasuser(): boolean{
    let auth : boolean = false;
      this._store.select((state) => state.authorize)
      .subscribe(
        (r) =>{
          if(r.authorize){
            auth = true;
          }else{
            auth = false;
          }
        }
      );
    return auth;
  }
}
